<template>
  <div class="contact-form">
    <form @submit="onFormSubmit">
      <!-- First Name -->
      <label for="firstName">
        <input
          id="firstName"
          v-model="form.firstName"
          type="text"
          name="firstName"
          placeholder="First Name"
          required
        >
      </label>
      <!-- Last Name -->
      <label for="lastName">
        <input
          id="lastName"
          v-model="form.lastName"
          type="text"
          name="lastName"
          placeholder="Last Name"
          required
        >
      </label>
      <!-- Email Address -->
      <label for="email">
        <input
          id="email"
          v-model="form.email"
          :class="emailError ? 'error' : ''"
          type="email"
          name="email"
          placeholder="Email Address"
          required
        >
      </label>
      <!-- Your School -->
      <label for="yourSchool">
        <input
          id="yourSchool"
          v-model="form.schoolName"
          type="text"
          name="yourSchool"
          placeholder="Your School's Name"
          required
        >
      </label>
      <!-- Your Role (dropdown after Last Name) -->
      <label for="your-role">
        <select
          id="your-role"
          v-model="form.schoolAffiliation"
          name="your-role"
          :class="{ selected: form.schoolAffiliation }"
          required
        >
          <option value="" disabled>What is your connection to the school?</option>
          <option value="School Administrator">School Administrator and/or Faculty</option>
          <option value="Current Student">Current Student</option>
          <option value="Alumni">Alumni</option>
          <option value="General School Supporter">General School Supporter</option>
          <option value="Consumer">Other</option>
        </select>
      </label>
      <!-- Type of School -->
      <!-- <label for="type-of-school">
        <select
          id="type-of-school"
          v-model="form.schoolType"
          name="type-of-school"
          :class="{ 'selected': form.schoolType }"
          required
        >
          <option value="" disabled>Select type of school</option>
          <option value="4 year">4 year</option>
          <option value="2 year">2 year</option>
          <option value="Trade School">Trade School</option>
        </select>
      </label> -->
      <!-- Error Message -->
      <div
        v-show="error"
        class="error"
      >
        Please make sure all fields are filled out properly.
      </div>
      <!-- Submit Button -->
      <input
        type="submit"
        value="SIGN UP"
        :disabled="disabled"
      >
    </form>
  </div>
</template>

<script>
// import axios from 'axios';
// import ThanksModal from '@/components/modals/ThanksModal.vue'; // No longer needed

export default {
  name: 'StayConnectedForm',

  data() {
    return {
      form: {
        email: '',
        firstName: '',
        lastName: '',
        schoolAffiliation: '', // Maps to your-role
        schoolName: '', // Maps to yourSchool
        schoolType: '' // Maps to type-of-school
      },
      error: false,
      emailError: false,
      disabled: false
    };
  },

  methods: {
    onFormSubmit(e) {
      e.preventDefault();
      this.disabled = true;

      // Validate email
      if (!this.validateEmail()) {
        this.disabled = false;
        return;
      }

      // Construct the URL with form data
      const searchParams = new URLSearchParams({
        cid: 861,
        id: 3,
        num_questions: 6,
        q_0: 1,
        q_1: 2,
        q_2: 3,
        q_3: 63,
        q_4: 62,
        q_5: 64,
        answer_1: this.form.email,
        answer_2: this.form.firstName,
        answer_3: this.form.lastName,
        answer_63: this.form.schoolAffiliation,
        answer_62: this.form.schoolName,
        answer_64: this.form.schoolType
      });

      // Redirect to the URL
      window.location.href = `https://e.notifications.retoolyourschool.com/forms/l.jsp?${searchParams.toString()}`;
    },

    validateEmail() {
      if (/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(this.form.email)) {
        this.error = false;
        this.emailError = false;
        return true;
      }

      this.error = true;
      this.emailError = true;
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.contact-form {
  input,
  textarea {
    background: #ffffff;
    border: 2px solid $thd-light-gray;
    padding: 12px 16px;
    margin-bottom: 8px;
    color: $thd-black;
    border-radius: 4px;
    display: block;
    width: 91.45%;

    &::placeholder {
      color: $thd-cool-gray;
    }

    &.error {
      border-color: $thd-orange;
    }

    &[type='submit'] {
      margin-top: 36px;
      width: 100%;
      background: $thd-orange;
      border: 3px solid $thd-orange;
      color: #ffffff;
      font-size: 18px;
      line-height: 24px;
      text-transform: uppercase;
      font-stretch: condensed;
      cursor: pointer;
      transition: background 0.4s;
      font-weight: 700;
      font-family: Arial, sans-serif;

      &:hover {
        background: $thd-white;
        color: $thd-orange;
      }

      &[disabled='disabled'] {
        background: $thd-white;
      }
    }
  }

  select {
    background: #ffffff;
    border: 2px solid #d5cfc9;
    border-radius: 4px;
    color: #040404;
    display: block;
    margin-bottom: 8px;
    padding: 12px 16px;
    width: calc(100% - 0px);
  }

  #your-role {
    color: #999999; /* Gray color for placeholder-like text */
    appearance: none;
    background: url('~@/assets/imgs/dropdown.png') no-repeat 98% #ffffff;

    &.selected {
      color: #000000; /* Normal text color (black) when selected */
    }

    option {
      color: #000000; /* Black for dropdown options */

      &:first-child {
        color: #999999; /* Black for dropdown options */
      }
    }
  }

  #type-of-school {
    color: #999999; /* Gray color for placeholder-like text */
    appearance: none;
    background: url('~@/assets/imgs/dropdown.png') no-repeat 98% #ffffff;

    &.selected {
      color: #000000; /* Normal text color (black) when selected */
    }

    option {
      color: #000000; /* Black for dropdown options */

      &:first-child {
        color: #999999; /* Black for dropdown options */
      }
    }
  }

  #message {
    height: 100px;
  }
}
</style>
